module.exports = __webpack_public_path__ + "img/tierra.ad2b4123.gif";